import Flex from '@deprecated-ui/common/Flex';
import Text from '@deprecated-ui/common/Text';
import Iconmoon, { IconWrapper } from '@deprecated-ui/common/Iconmoon';

interface PinnedLabelProps {
  isCompanyPinnedPost: boolean;
  text?: string;
  marginBottom?: string;
}

function PinnedLabel({
  isCompanyPinnedPost,
  text = 'Pinned Post',
  marginBottom = '16px',
}: PinnedLabelProps) {
  const color = isCompanyPinnedPost ? '#858585' : '#e32072';
  return (
    <Flex
      // @ts-expect-error
      ml={isCompanyPinnedPost ? '0px' : '50px'}
      align="center"
      mb={marginBottom}
    >
      <IconWrapper>
        <Iconmoon className="icon-toolbar_pinned" size="16px" color={color} />
      </IconWrapper>
      {/* @ts-expect-error */}
      <Text ml={isCompanyPinnedPost ? '4px' : '8px'} color={color}>
        {isCompanyPinnedPost ? 'Pinned Post by Stockbit' : text}
      </Text>
    </Flex>
  );
}

export default PinnedLabel;
